<p-toast [style]="{marginTop: '41vh'}" position="top-center" key="cxcimpnd"></p-toast>
<p-confirmDialog [transitionOptions]="'0ms'" key="cxcimpndconfirm" title="Confirmar Acción" appendTo="body">
</p-confirmDialog>
<div class="p-grid" style="width: 98%">
    <div class="p-col-12">
        <app-invmaebarra (signal)="manejarSenales($event)" [botonNuevo]="botonNuevo" [botonGuardar]="botonGuardar"
            [botonBorrar]="botonBorrar" [botonRegresar]="false" [barraBotones3]="true" [barraBotones3]="true"
            [barraBotonesAsiCon]="true" [botonPrimero]="!botonPrimero" [botonAnterior]="!botonAnterior"
            [botonSiguiente]="!botonSiguiente" [botonUltimo]="!botonUltimo" [barraBotones5]="true"
            [botonBuscarPermanente]="true" [botonDescargaPermanente]="true" [botongenerand]="true"
            [botonImprimirPermanente]="true"
            [botonreversand]="true"></app-invmaebarra>
    </div>
</div>
<div class="p-grid" style="margin-top: -10px; margin-bottom: -10px; width: 99%;">
    <!--LINEA 1-->
    <div class="p-col-5">

    </div>
    <div class="p-col-1">
        <label for="lblestado"></label>
        <input class="frm" id="lblestado" type="text" pInputText
            style="background-color: rgb(40,138,210); font-weight: bold; color: white;" [disabled]="true"
            [(ngModel)]="lblestado" (keydown.enter)="setFocus($event)" autocomplete="off">
    </div>

</div>
<p-tabView [(activeIndex)]="index" (onChange)="changeTabs()" [style]="{'width':'98%'}">
    <p-tabPanel header="General">
        <p-scrollPanel [style]="{'width':'100%', 'height':'calc(100vh - 270px)'}">
            <div class="contorno" id="contorno">
                <div class="divgrups">
                    <div class="p-grid">
                        <!--LINEA 1-->
                        <div class="p-col-1">
                            <span>Número:</span>
                        </div>
                        <div class="p-col-1">
                            <label for="ENCNDCLI_NUMERO"></label>
                            <input class="frm" id="ENCNDCLI_NUMERO" type="text" pInputText disabled
                                [(ngModel)]="cxcimportarndService.encndcli[indicador].ENCNDCLI_NUMERO"
                                style="color: blue; font-weight: bold;" autocomplete="off">
                        </div>
                        <!-- <div class="p-col-1">
                            <span>Banco:</span>
                        </div>
                        <div class="p-col-2">
                            <label for="BAN_CODIGO"></label>
                            <input class="frm" id="BAN_CODIGO" type="text" pInputText [disabled]="cxcimportarndService.encndcli[indicador].ENCNDCLI_NUMERO !== ''"
                                [(ngModel)]="cxcimportarndService.encndcli[indicador].BAN_CODIGO"
                                (keydown.enter)="setFocus($event)" (keydown)="botonesmodificar()"
                                autocomplete="off">
                        </div>
                        <div class="p-col-1">
                            <button type="button"
                                style="background-image: url(../../../assets/images/iconos/buscar.webp);"
                                (click)="busquedabanco(cxcimportarndService.encndcli[indicador].BAN_CODIGO)"></button>
                        </div>
                        <div class="p-col-3">
                            <label for="lblbannombre"></label>
                            <input class="frm" id="lblbannombre" type="text" pInputText disabled
                                style="color: blue;"
                                [(ngModel)]="lblbannombre"
                                autocomplete="off">
                        </div> -->
                        <!--LINEA 2-->
                        <div class="p-col-12" style="margin-top: -10px">
                            <div class="p-grid">
                                <div class="p-col-1">
                                    <span>Fecha:</span>
                                </div>
                                <div class="p-col-1">
                                    <p-calendar id="ENCNDCLI_FECHA" [inputStyle]="{width: '100%', height: '20px'}"
                                        [(ngModel)]="cxcimportarndService.encndcli[indicador].ENCNDCLI_FECHA"
                                        [readonlyInput]="false" dateFormat="dd/mm/yy" (keydown.enter)="setFocus($event)"
                                        (keydown)="botonesmodificar()">
                                    </p-calendar>
                                </div>
                                <div class="p-col-1">
                                    <span>Concepto:</span>
                                </div>
                                <div class="p-col-5">
                                    <label for="ENCNDCLI_CONCEPTO"></label>
                                    <input class="frm" id="ENCNDCLI_CONCEPTO" type="text" pInputText
                                        [(ngModel)]="cxcimportarndService.encndcli[indicador].ENCNDCLI_CONCEPTO"
                                        maxlength="98" (keydown.enter)="setFocus($event)" (keydown)="botonesmodificar()"
                                        autocomplete="off">
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <app-aggridsaci [width]="" [height]="80" [enableSorting]="false" [enableFilter]="true"
                [rowData]="cxcimportarndService.detndcli" [frameworkComponents]="frameworkComponents"
                [animateRows]="true" [rowSelection]="rowSelection" [columnDefs]="columnDefsDetndcli"
                [defaultColDef]="defaultCxcdetndcli" [rowStyle]="rowStyle" [singleClickEdit]="false" [botones]="true"
                [mostrarGuardar]="false" [botonesAdicionales]="false" [comboOpciones]="" [solobotoneliminar]="true"
                [btnsubirxls]="false" (selected)="seleccionItem($event)" [tipodetalle]="" [botonBorrar]="true"
                (cambios)="cambio($event)" [CC]="true">
            </app-aggridsaci>
            <!-- <div class="divgrups" style="margin-top: 10px;">
                <div class="p-grid" style="margin-bottom: -10px;">
                    <div class="p-col-4">
                        <span>Notas de débito ya registrados en bancos o en registro de comprobantes</span>
                    </div>
                    <div class="p-col-1" style="margin-top: 10px; height: 25%; background-color: rgb(245,236,166)">
                    </div>
                    <div class="p-col-1">
                        <span for="total" class="obligatorio">Total:</span>
                    </div>
                    <div class="p-col-4">
                        <input type="text" id="total" class="totales" [disabled]="true"
                            [(ngModel)]="cxcregcomprobanteService.regtotal" autocomplete="off">
                    </div>
                </div>
            </div> -->
        </p-scrollPanel>
    </p-tabPanel>
</p-tabView>

<input #inputFile type="file" style="display: none; opacity: 0.0; position: absolute; 
			top: 0; left: 0; bottom: 0; right: 0; width: 25px; height: 25px; cursor: pointer;" accept=".xls, .xlsx"
    (change)="onBasicUpload(inputFile.files)" />
    
<p-dialog header="Busqueda de Datos" [(visible)]="displayDialogBusquedaFast" [transitionOptions]="'0ms'" [modal]="true"
    appendTo="body" [style]="{width: '70vw', height: '70vh'} ">
    <app-busquedadlg [arrayOptions]="types" [arregloConsulta]="arregloCons" [consulta]="consulta" [tabla]="tabla"
        [where]="where" [busquedaParams]="busquedacampos" (opcionSeleccionada)="manejarSeleccion($event)">
    </app-busquedadlg>
</p-dialog>

<p-dialog header="Clave Autorización" [(visible)]="displayDialogAutorizacion" [transitionOptions]="'0ms'" [modal]="true"
	appendTo="body" (onHide)="onHideAutorizacion()" [style]="{width: '40vw', height: 'auto'} ">
	<p-toast [style]="{marginTop: '41vh'}" position="top-center" key="autorizacion"></p-toast>
	<div class="divgrups">
		<div class="p-grid">
			<div class="p-col-12">
				<div class="p-grid">
					<div class="p-col-1"></div>
					<div class="p-col-4">
						<label for="clave" style="font-weight: bold">Clave de Autorización:</label>
					</div>
					<div class="p-col-2"></div>
					<div class="p-col-4">
						<input type="password" pInputText id="clave" [(ngModel)]="claveAuth"
							(keydown.enter)="comprobarClave()" placeholder="Ingrese la clave">
					</div>
					<div class="p-col-1"></div>
				</div>
			</div>
		</div>
	</div>
</p-dialog>

<p-dialog header="Reportes" [(visible)]="displayDialogReportes" [transitionOptions]="'0ms'" [modal]="true"
	appendTo="body" [style]="{width: '40vw', height: '400px'}">
	<app-sacimaecfngimpr [auxiliar]="auxreporte" [strNombreForma]="strNombreForma"
        [strNumDoc]="cxcimportarndService.encndcli[indicador].ENCNDCLI_NUMERO" [strCampo]="'ENCNDCLI_NUMERO'"
        [botonExcel]="true"
		(cerrar)="cerrarReportes()"></app-sacimaecfngimpr>
</p-dialog>